<template>
  <ContentWithHeader>
    <template #header>
      <div>
        <button
          class="btn no-bg"
          @click="onClickBack()">
          <i
            v-if="section.prev == 'choose-product'"
            class="fas fa-times"/>
          <i
            v-if="section.prev == 'choose-attribute'"
            class="fas fa-chevron-left"/>
        </button>
      </div>
      <div class="col text-center">
        {{ getProductFullName(product.product_name, getSku(product.prices, sku_id).attributes) }}
      </div>
      <div/>
    </template>
    <template #content>
      <section class="section">
        <div class="wrapper-calculator">
          <span class="label">
            {{ $t('message.price') }}
          </span>
          <calculator-view
            :compare="false"
            @submit="onSubmitCalc"/>
        </div>
      </section>
    </template>
  </ContentWithHeader>
</template>

<script>
import customPriceMixin from '@/mixins/pos/customPrice'
import ContentWithHeader from '../common/ContentWithHeader.vue'

export default {
  mixins: [customPriceMixin],

  components: {
    ContentWithHeader,
  },
}
</script>

<style scoped>
  .section {
    margin-top: 80px;
    height: 100%;
  }
  .wrapper-calculator {
    width: 90%;
    height: 500px;
    margin: auto;
    position: relative;
  }
  .wrapper-quickcashpayment {
    width: 90%;
    margin: auto;
  }

  @media (min-width: 1023px) {
    .wrapper-calculator {
      width: 600px;
      height: 500px;
    }
    .wrapper-quickcashpayment {
      width: 600px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/mobile/include/CustomPrice.vue